import { api } from "@tc/ui";
let feed = null;
const listeners = new Set();
let timer = null;
let inflight = null;
export function refreshTasks() {
    if (inflight)
        return inflight;
    inflight = api("/api/m/tasks/bar").then((f) => { feed = f; for (const l of listeners)
        l(f); }, () => undefined).finally(() => { inflight = null; });
    return inflight;
}
export function subscribe(fn) {
    listeners.add(fn);
    fn(feed);
    if (!timer) {
        void refreshTasks();
        timer = window.setInterval(() => void refreshTasks(), 60_000);
        document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible")
            void refreshTasks(); });
    }
    return () => { listeners.delete(fn); };
}
/** Sign off / acknowledge from anywhere in the shell, then refresh everything. */
export async function quickClear(t) {
    const ack = t.clear_mode === "ack_change" || t.clear_mode === "ack_hours";
    const r = await api(`/api/m/tasks/task/${t.id}/${ack ? "ack" : "sign-off"}`, { body: ack ? {} : { note: "" } });
    await refreshTasks();
    return r.message ?? (ack ? "Acknowledged." : "Signed off.");
}
